// loan app
export var API_ROOT = {
  root: '/',
  auth: '/api/authpresentation/',
  app: '/Underwriter/LoanApplications/',
  admin: '/Admin/',
  queues: '/Underwriter/LoanApplications/',
  held: '/underwriter/HeldInboundApps/',
  manual: '/underwriter/ManualAppEntry/',
  vehicle: '/vehicleInfo/',
  publishRules: '/admin/publishRules/',
  lookupTables: '/admin/lookupTables/',
  decisionHistoryPage: '/admin/selectionAdmin/',
  collateral: '/collateral/',
  vfApp: '/funder/LoanApplications/',
  crosssellconfiguration: '/admin/crosssellconfiguration/'
}; // auth api

export var ACCOUNT_USER = 'user';
export var ACCOUNT_TOKEN = 'token';
export var ACCOUNT_PING = 'ping';
export var ACCOUNT_LOGOUT = 'account/logout';
export var ACCOUNT_CHANGE_PASSWORD = 'account/password';
export var ACCOUNT_RESET_PASSWORD = 'account/resetpassword'; // Requires UserName

export var ACCOUNT_FORGOT_PW = 'account/forgotpassword'; // Requires UserName & Password

export var ACCOUNT_FORGOT_PW_CONFIRM = 'account/forgotpassword/confirm';
export var ACCOUNT_LOGIN = 'token';
export var VALIDATE_MFA_CODE = 'token/validatemfa';
export var LOGIN_HELP_TEXT = 'home/getlogintext';
export var LOGIN_BACKGROUND_IMG = 'home/getbackground';
export var HOME_UNLOCK = 'Home/Unlock?loanApplicationId=';